
import {HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {finalize, switchMap} from 'rxjs';
import {environment} from '@env/environment';
import {inject} from '@angular/core';
import {OdooService} from '@services/odoo.service';

export function AuthInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
) {
  switch (true) {
    case request.url.indexOf(environment.api.BE+`/hr`) !== -1:
      return handleOdooAuth(request, next);
    case request.url.indexOf(environment.api.BE+`/ims`) !== -1:
      return handleOdooAuth(request, next);
    case request.url.indexOf(environment.api.metafora) !== -1:
      return handleMetaforaAuth(request, next);
    default:
      return next(request);
  }
}

function handleOdooAuth(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
) {
  const odooService = inject(OdooService);
  return odooService.sessionId$
    .pipe(
      switchMap((token: string|undefined) => {
        if (request.method === 'POST') {
          const cloned = request.clone(token ? {
            setHeaders: {
              'X-Openerp-Session-Id': token,
              'Content-Type': 'application/json'
            }
          } : {});
          return next(cloned).pipe(finalize(() => {
          }));
        } else if (request.method === 'GET') {
          const cloned = request.clone(token ? {
            setHeaders: {
              'X-Openerp-Session-Id': token
            }
          } : {});
          return next(cloned).pipe(finalize(() => {
          }));
        } else {
          return next(request);
        }
      })
    )
}


function handleMetaforaAuth(
    request: HttpRequest<unknown>,
    next: HttpHandlerFn
  ) {
        if (request.method === 'POST') {
          const cloned = request.clone({
            setHeaders: {
              'api-key': environment.metafora.apiKey,
              'Content-Type': 'application/json'
            }
          });
          return next(cloned).pipe(finalize(() => {
          }));
        } else if (request.method === 'GET') {
          const cloned = request.clone({
            setHeaders: {
              'api-key': environment.metafora.apiKey
            }
          });
          return next(cloned).pipe(finalize(() => {
          }));
        } else {
          return next(request);
        }
    }
